<!-- Page Title -->
<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content text-white">
                    <h2>Preise</h2>
                    <ul class="text-gray-200">
                        <li><a routerLink="/" class="hover:underline">Startseite</a></li>
                        <li>Preise</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="default-shape hidden md:block">
        <div class="shape-1"><img src="assets/img/shape/1.png" alt="shape" /></div>
        <div class="shape-2 rotateme"><img src="assets/img/shape/2.png" alt="shape" /></div>
        <div class="shape-3"><img src="assets/img/shape/3.svg" alt="shape" /></div>
        <div class="shape-4"><img src="assets/img/shape/4.svg" alt="shape" /></div>
        <div class="shape-5"><img src="assets/img/shape/5.png" alt="shape" /></div>
    </div>
</div>

<!-- Preise Content -->
<section class="py-20 bg-white">
    <div class="container mx-auto px-4 max-w-4xl text-gray-800">
        <div class="container">
            <div class="section-title">
                <h2>Preise – Führerscheinklasse B</h2>
                <div class="bar"></div>
                <p>Faire und transparente Preise – keine versteckten Kosten. Alle Preise verstehen sich inklusive 19 % MwSt.</p>
            </div>

            <div class="tab pricing-list-tab">
                <ul class="tabs">
                    <li class="active"><a href="#">Einzelpreise</a></li>
                </ul>

                <div class="tab_content">
                    <!-- Einzelpreise -->
                    <div class="tabs_item active">
                        <div class="row">
                            <div class="col-lg-4 col-md-6">
                                <div class="single-pricing-table">
                                    <div class="pricing-header">
                                        <h3>Grundbetrag</h3>
                                    </div>
                                    <div class="price">
                                        <sup>€</sup>350
                                    </div>
                                    <ul class="pricing-features">
                                        <li><i class="fas fa-check"></i> Inklusive Lern-App</li>
                                        <li><i class="fas fa-check"></i> Theorieunterricht (14 Einheiten)</li>
                                        <li><i class="fas fa-check"></i> Persönliche Betreuung</li>
                                    </ul>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6">
                                <div class="single-pricing-table">
                                    <div class="pricing-header">
                                        <h3>Fahrstunden</h3>
                                    </div>
                                    <div class="price">
                                        <sup>€</sup>75 <sub>/45 Min</sub>
                                    </div>
                                    <ul class="pricing-features">
                                        <li><i class="fas fa-check"></i> Übungsfahrt: €75</li>
                                        <li><i class="fas fa-check"></i> Sonderfahrt: €75</li>
                                        <li><i class="fas fa-check"></i> Flexible Terminvereinbarung</li>
                                    </ul>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6">
                                <div class="single-pricing-table">
                                    <div class="pricing-header">
                                        <h3>Prüfungen & Materialien</h3>
                                    </div>
                                    <div class="price">
                                        <sup>ab €</sup>75
                                    </div>
                                    <ul class="pricing-features">
                                        <li><i class="fas fa-check"></i> Theorieprüfung: €95</li>
                                        <li><i class="fas fa-check"></i> Praktische Prüfung: €215</li>
                                        <li><i class="fas fa-check"></i> Lernmaterial inklusive</li>
                                        <li><i class="fas fa-times"></i> TÜV-Gebühr nicht enthalten</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>



    </div>
</section>
<app-subscribe></app-subscribe>
